module.exports = __webpack_public_path__ + "img/3.418e5c0f.png";